import React, { useState, useEffect ,useRef} from 'react';
import { Button,Modal, Form, Input, Spin, Select, Row, Col} from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message';
import context from '../../public/js/context';
import trans from './translation';
import './liteAdmin.css';

const { Option } = Select;

const RoleFromModal = (props) => {
    const messageRef = useRef();
    const [form] = Form.useForm();
    const [sysRoleList, setSysRoleList] = useState([]);
    const [isLoad, setIsLoad] = useState(false);
    const sysRoleModel = props.model;

    useEffect(() => {
        searchRole();
        initForm(sysRoleModel);
    }, []);
    
    const searchRole = () => {
        Base.callBackApi("role/searchRole").then((data) => {
            if ("SUCCESS" === data.msg) {
                let list = data.object ?? [];
                // setSysRoleList(list.filter(item => item.roleCode !== "STUDENT" && item.roleCode !== "PROGRAMME_LEADER" && item.roleCode !== "MODULE_CONVENER" && item.roleCode !== "ACADEMIC_SUPERVISOR" && item.roleCode !== "INDUSTRIAL_PARTNER" && item.roleCode !== "INDUSTRIAL_SUPERVISOR"));
                setSysRoleList(list.filter(item => item.roleCode === "LITE_ADMIN"));
            } else {
                this.errFrameShow("error", data.msg);
            }
        }).catch(err => { });
    }

    const initForm = (model) => {
        form.setFieldsValue({
            roleId: model.roleId ?? "",
            roleCode: model.roleCode ?? "",
            activeInd: model.activeInd ?? "",
            defaultInd: model.defaultInd ?? "",
        });
    }

    const roleIdChnage = (value) => {
        let model = sysRoleList.find(item => item.roleId == value);
        form.setFieldsValue({ roleCode: model?.roleCode ?? "" });
    }

    const defaultIndChnage = (value) => {
        if(value === "Y") {
            form.setFieldsValue({ activeInd: 'Y' });
        }
    }

    const activeIndChange = (value) => {
        if(value === "N") {
            form.setFieldsValue({ defaultInd: 'N' });
        }
    }

    const save = () => {
        form.submit();
    }

    const onFinish = (values) => {
        messageShowHandler();
        setIsLoad(true);
        let url = "";
        if(sysRoleModel?.userRoleId) {
            url = "user/updateUserRole";
            values.userRoleId = sysRoleModel?.userRoleId;
            values.lastUpdatedDate = sysRoleModel?.lastUpdatedDate;
        } else {
            url = "user/insertUserRole";
        }
        values.phone = props.phone;
        values.userId = props.userId;
        values.menuFuncId = Config.funcInfo.funcId;
        Base.callBackApi(url, values).then((data) => {
            if ("SUCCESS" === data.msg) {
                onCancel(true);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const onCancel = (flag = false) => {
        props.onClose(flag);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style)
        messageRef.current.setContent(msg)
        messageRef.current.setIsShow(true)
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false)
    }

    return(
        <Spin size="large" spinning={isLoad} tip={trans.dataBeSaving[Config.backLang]}>
            <Modal
                visible={true}//控制弹框是否显示
                title={trans.addRole[Config.backLang]}//标题
                centered//垂直居中
                destroyOnClose={true}//关闭即销毁？
                closable//是否显示右上角的关闭按钮
                maskClosable={false}//点击蒙层是否允许关闭	
                // width={Config.equipmentInfo.type === 'iPad' ? '65%' : (Config.equipmentInfo.type === 'phone' ? '100%' : '50%')}//弹框宽度
                width={'890px'}
                onCancel={() => onCancel(false)}//点击取消触发事件
                footer={[
                    <Button key='save'className="sysBtn btnBlue"  type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.save[Config.backLang]}</Button>, 
                    <Button key='cancel' className="sysBtn" onClick={() => onCancel(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
                ]}
            >
                <Message ref={messageRef} />
                <Form form={form} onFinish={onFinish}>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitles mustFill">{trans.roleName[Config.backLang]}</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="roleId"
                                    rules={[
                                        { required: true,  message: trans.roleNameIsNoNull[Config.backLang] },
                                    ]}
                                >
                                    <Select onChange={(value) => roleIdChnage(value)} className='sysSelect'>
                                        <Option value=""></Option>
                                        {sysRoleList.map((item) => <Option key={item.roleId} value={item.roleId}>{item.roleName}</Option>)}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        <div className='sysColMin'>
                            <div className="sysTitleMax">{trans.defaultInd[Config.backLang]}</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="defaultInd"
                                    rules={[
                                        { required: true,  message: trans.defaultIndIsNoNull[Config.backLang] },
                                    ]}
                                >
                                    <Select onChange={(value) => defaultIndChnage(value)} className='sysSelect'>
                                        <Option value=""></Option>
                                        {context.indsTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                        {/* {context.inds.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)} */}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitles">{trans.roleCode2[Config.backLang]}</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="roleCode"
                                >
                                    <Input type="text" placeholder={trans.roleCode2[Config.backLang]} disabled maxLength={50}/>
                                </Form.Item>
                            </div>
                        </div>
                        <div className='sysColMin'>
                            <div className="sysTitleMax">{trans.jHActiveInd[Config.backLang]}</div>
                            <div className="sysSerchInput">
                                <Form.Item
                                    name="activeInd"
                                    rules={[
                                        { required: true,  message: trans.jHActiveIndIsNoNull[Config.backLang] },
                                    ]}
                                >
                                    <Select onChange={(value) => activeIndChange(value)} className='sysSelect'>
                                        <Option value=""></Option>
                                        {context.indsTransalation.map((item) => <Option key={item.value} value={item.value}>{item[Config.backLang]}</Option>)}
                                        {/* {context.inds.map((item) => <Option key={item.value} value={item.value}>{item.label}</Option>)} */}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Form>
            </Modal>
        </Spin>
    )

}

RoleFromModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    phone: PropTypes.number.isRequired,
    userId:PropTypes.number.isRequired,
    model: PropTypes.object.isRequired,
}

export default RoleFromModal;